import React from 'react';
import styled from "styled-components";

const CircularRadioInput = ({ action, checked, label, color, hasError }) => {
    let height = '8px', width = '8px', borderWidth = '2px', activeColor = '#555', dotBackground = 'transparent';
    if (checked) {
        activeColor = color;
        dotBackground = color;
    }
    return (
        <div style={{ cursor: 'pointer' }}>
            <div
                onClick={() => action()}
                style={{
                    display: 'inline-block',
                    boxSizing: 'border-box',
                    padding: '2px',
                    verticalAlign: 'middle',
                    border: `${borderWidth} solid ${hasError ? 'red' : color}`,
                    // border: `${borderWidth} solid ${activeColor}`,
                    borderRadius: '24px'
                }}
            >
                <div style={{ height, width, background: dotBackground, borderRadius: '24px' }} />
            </div>
            <span
                style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginLeft: '10px', 
                    fontFamily: 'MTNRegular',
                    color: activeColor,
                    fontSize: '12px',
                }}
                onClick={() => action()}>
                {label}
            </span>
        </div>
    )
}
const MainHolder = styled.div`
    display: grid;
    align-content: space-between;
    grid-template-rows: auto auto 1fr;
    overflow: hidden;
    scrollbar-width: none;
    background-color: ${({ activeTheme }) => activeTheme};
    height: 700px;
    position: relative;
    @media screen and (max-width: 480px) {
      border-radius: 0px;
      padding-bottom: 5px;
      height: 100vh;
    }
  `;

const AlertCurveTop = styled.div`
    position: absolute;
    width: 225%;
    height: 70%;
    top: 30%;
    left: -62%;
    backgroundColor: '#fff';
    border-top-left-radius: 50%;
    background-color: rgb(255, 255, 255);
    border-top-right-radius: 50%;
  `

const AlertIconContainer = styled.div`
    margin: 0px auto;
    background-color: rgb(245, 130, 30);
    height: 100px;
    width: 100px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: center;
  `

const Children = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
  `;

const BackButtonContainer = styled.div`
    background-color: #ffcc00;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    margin: 8px;
    z-index: 5;
  `;

const Header = styled.div`
    width: 100%;
    height: 300px;
    overflow: hidden;
    position: relative;
    padding: 20;
  `;

const Image = styled.img`
    width: 100%;
    height: 360px;
    position: absolute;
  `;
const Gradient = styled.div`
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.17) 39.58%,
      #000000 100%
    );
    position: absolute;
    z-index: 1;
    display: grid;
    grid-auto-flow: column;
    align-items: flex-start;
  `;
const GradientBody = styled.div`
    padding: 5px;
    display: flex;
    flex-direction: column;
    height: 80%;
    justify-content: flex-end;
  `;

const DescriptionBody = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${({ color }) => color};
    align-items: center;
    position: relative;
    z-index: 1;
  `;

const ContentHolder = styled.div`
    width: 100%;
    height: auto;
  `;

const MovieList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `;

const MovieHolder = styled.div`
    width: 90%;
    height: 103px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    margin-bottom: 10px;
    border-radius: 20px;
    display: flex;
    padding: 5px;
    align-items: center;
  `;

const MovieImage = styled.img`
    width: 85px;
    height: 85px;
    border-radius: 5px;
  `;

const MovieContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 150px;
    align-items: flex-start;
    margin: 20px;
  `;

const ButtonHolder = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  `;

const StyledTextInput = styled.input`
    padding: 10px;
    outline: none;
    font-family: MTNRegular;
    border: 1px solid #999;
    border-radius: 7px;
    min-width: 200px;
    width: 80%;
    text-align: center;
  `

const DescriptionItems = styled.div`
    display: flex;
  `;

const CircleContainer = styled.div`
    display: flex;
    align-items: flex-start;
    padding-inline: 10px;
  `;

const ColorCircle = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: ${({ color }) => color};
    margin-right: 10px;
  `;

export default CircularRadioInput;